import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, timer } from 'rxjs';
import { DisplayError, ErrorKey, ErrorService } from './error.service';

interface ErrorMap {
  [errorKey: string]: {
    code?: number;
    timerSub?: Subscription;
  }
}

@Injectable()
export class BrowserErrorService extends ErrorService {

  private readonly _currentErrorMap: ErrorMap = {};
  private readonly _allErrorsSubject = new BehaviorSubject<DisplayError[]>([]);

  public readonly allErrors = this._allErrorsSubject.asObservable();

  private _emitMapAsArray() {
    const arr = Object.keys(this._currentErrorMap).map(key => ({
      msgKey: key,
      code: this._currentErrorMap[key].code
    }));

    this._allErrorsSubject.next(arr);
  }

  private _clearAfter(errorKey: ErrorKey, seconds: number): Subscription {
    return timer(seconds * 1000).subscribe(() => {
      delete this._currentErrorMap[errorKey];
      this._emitMapAsArray();
    });
  }

  public clearError(errorKey: ErrorKey, emit = true) {
    if (this._currentErrorMap[errorKey] && this._currentErrorMap[errorKey].timerSub) {
      this._currentErrorMap[errorKey].timerSub.unsubscribe();
    }
    delete this._currentErrorMap[errorKey];
    if (emit) this._emitMapAsArray();
  }

  public clearAllErrors() {
    Object.keys(this._currentErrorMap).forEach(key => this.clearError(<ErrorKey>key, false));
    this._emitMapAsArray();
  }

  /**
   * @param errorKey error translation key
   * @param code any error code that might be returned from server to give extra context.
   * @param secondsToDisplay clear this error from screen after X seconds
   */
  public displayError(errorKey: ErrorKey, code?: number, secondsToDisplay?: number) {
    if (!this._currentErrorMap[errorKey]) {
      this._currentErrorMap[errorKey] = { code: code };
      if (secondsToDisplay) this._currentErrorMap[errorKey].timerSub = this._clearAfter(errorKey, secondsToDisplay);
    } else if (this._currentErrorMap[errorKey].timerSub && secondsToDisplay) {
      this._currentErrorMap[errorKey].timerSub.unsubscribe();
      this._currentErrorMap[errorKey].timerSub = this._clearAfter(errorKey, secondsToDisplay);
    }
    this._emitMapAsArray();
  }

}
